import { useEffect, type Dispatch, type SetStateAction } from 'react';
import type { ConfiguredAddOn } from '../types/addon.types';
import type { ConfiguredService } from '../types/service.types';
import { pruneOrphanedAddOns, isLinkedServiceSelectable } from '../utils/linkedAddOns';

// Guided removal and re-derivation both replace configured service rows
// wholesale, so add-on links have to be reconciled whenever that list changes.
export function useLinkedAddOnSync({
    configuredServices,
    configuredAddOns,
    setConfiguredAddOns,
    selectedLinkedServiceId,
    onLinkedServiceUnavailable,
}: {
    configuredServices: ConfiguredService[];
    configuredAddOns: ConfiguredAddOn[];
    setConfiguredAddOns: Dispatch<SetStateAction<ConfiguredAddOn[]>>;
    selectedLinkedServiceId: string;
    onLinkedServiceUnavailable: () => void;
}): void {
    useEffect(() => {
        const retained = pruneOrphanedAddOns(configuredAddOns, configuredServices);
        if (retained.length !== configuredAddOns.length) {
            setConfiguredAddOns(retained);
        }
    }, [configuredServices, configuredAddOns, setConfiguredAddOns]);

    useEffect(() => {
        if (!isLinkedServiceSelectable(selectedLinkedServiceId, configuredServices)) {
            onLinkedServiceUnavailable();
        }
    }, [selectedLinkedServiceId, configuredServices, onLinkedServiceUnavailable]);
}
